import React from 'react';
import PropTypes from 'prop-types';

import GamedayLogo from '../GamedayLogo';

const LoginContainer = ({ children }) => (
  <div className='loginPage u-full-width'>
    <div className='loginPage__logo ncss-col-sm-12 ncss-col-md-6 full'>
      <div className='flex-container center u-full-height'>
        {/* We pass two here because mobile needs the alternate color version */}
        <div className='d-sm-h d-md-b'>
          <GamedayLogo isLight />
        </div>
        <div className='d-md-h'>
          <GamedayLogo />
        </div>
      </div>
    </div>
    <div className='loginPage__form_wrap ncss-col-sm-12 ncss-col-md-6 full'>
      <div className='flex-container center prl7-sm u-full-height'>{children}</div>
    </div>
  </div>
);

LoginContainer.propTypes = {
  children: PropTypes.any.isRequired
};

export default LoginContainer;
